module.exports = __webpack_public_path__ + "static/media/galerija_2017 (16).6e0d41cb.jpg";